import { LineWithQuantities } from '@core/services/basket/basket-mapping-utils';

export const calculateLineTotal = (total: number, product: LineWithQuantities): number => {
    const unitPrice = calculateUnitPriceAmountWithDiscount(product.initialQuantity || 1, product.priceAmountRaw);
    total += Number((unitPrice * product.quantity).toFixed(2));
    return Math.abs(total);
};

export const calculateRemoveLineTotal = (total: number, product: LineWithQuantities): number => {
    const unitPrice = calculateUnitPriceAmountWithDiscount(product.initialQuantity || 1, product.priceAmountRaw);
    total -= Number((unitPrice * product.quantity).toFixed(2));
    return Math.abs(total);
};

/**
 * This need to be calculated on the FE since the BE is summing all the values and return to the FE
 * and we need, for tracking purpose, the unit discount price
 * @param quantityInBasket
 * @param discountAmount
 */
export const calculateUnitDiscountAmount = (quantityInBasket: number, discountAmount: number): number =>
    Number((discountAmount / quantityInBasket).toFixed(2));

/**
 * This need to be calculated on the FE since the BE is summing all the values and return to the FE
 * and we need, for tracking purpose, the unit price
 * @param quantityInBasket
 * @param priceAmount
 */
export const calculateUnitPriceAmountWithDiscount = (quantityInBasket: number, priceAmount: number): number =>
    Number((priceAmount / quantityInBasket).toFixed(2));
